const MAX_SCREEN_SIZE: number = 1600;

export class HsCanvasSize {
  public realWidth: number;
  public realHeight: number;

  public renderWidth: number;
  public renderHeight: number;

  public aspect: number;

  constructor(width: number = 1, height: number = 1, public top: number = 0, public left: number = 0) {
    this.realWidth = this.validateSize(Math.round(width));
    this.realHeight = this.validateSize(Math.round(height));

    if (this.realWidth <= MAX_SCREEN_SIZE && this.realHeight <= MAX_SCREEN_SIZE) {
      this.renderWidth = this.realWidth;
      this.renderHeight = this.realHeight;
      this.aspect = this.getAspect();
      return;
    }
    if (this.realWidth > this.realHeight) {
      this.renderWidth = MAX_SCREEN_SIZE;
      this.renderHeight = this.getProportionMaxSize(this.realHeight / this.realWidth);
      this.aspect = this.getAspect();
      return;
    }
    this.renderWidth = this.getProportionMaxSize(this.realWidth / this.realHeight);
    this.renderHeight = MAX_SCREEN_SIZE;
    this.aspect = this.getAspect();
  }

  public copy(otherCanvasSize: HsCanvasSize): HsCanvasSize {
    this.aspect = otherCanvasSize.aspect;
    this.left = otherCanvasSize.left;
    this.realHeight = otherCanvasSize.realHeight;
    this.realWidth = otherCanvasSize.realWidth;
    this.renderHeight = otherCanvasSize.renderHeight;
    this.renderWidth = otherCanvasSize.renderWidth;
    this.top = otherCanvasSize.top;

    return this;
  }

  private getProportionMaxSize(aspectRatio: number): number {
    return this.validateSize(Math.round(MAX_SCREEN_SIZE * aspectRatio));
  }

  private validateSize(size: number): number {
    return size < 1 ? 1 : size;
  }

  private getAspect(): number {
    return this.renderWidth / this.renderHeight;
  }
}
